import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkOut = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M31.999 16.996v-1h-5.997v2h2.583l-5.296 5.296 1.414 1.414 5.296-5.296V22h2v-5.004zM16.002 32V16h8v2h-6v12h12v-6h2v8h-16z"
	})
});
export default SvgLinkOut;
